/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_ALL_EVENTS_LIST = gql`
query GetListOfCyclone($input: GetListOfCycloneInput) {
  getListOfCyclone(input: $input) {
    data {
      eventId
      exposure
      stormName
      vmin
      vmax
      date
      country
      category
      status
      closingReason
      blockchainProof
      closedBy {
        vuid
        email
        firstName
        lastName
      }
      payoutEstimate
    }
    currentPage
    pageSize
    totalCount
    totalPages
  }
}
`
;
